// React/Redux
import React, { Component } from "react";
import { connect } from "react-redux";

// Material UI
import ButtonBase from "@material-ui/core/ButtonBase";

// PAC
import { salesStatuses } from "./salesStatuses";

class AwardPendingArrow extends Component {
  state = {
    activities: []
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const { activities } = this.props;

      this.setState({
        activities
      });
    }
  }

  onClick = e => {
    e.preventDefault();
    this.props.onClick("Award Pending", salesStatuses.AWARD_PENDING);
  };

  render() {
    return (
      <div className="arrow-container">
        <div className="arrow-btn arrow-award-pending">
          <ButtonBase onClick={this.onClick}>
            <span className="arrow-btn-label">
              {this.state.activities.length} <br />
              Award Pending
            </span>
          </ButtonBase>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activities: state.salesActivity.awardPending
  }
}

export default connect(mapStateToProps)(AwardPendingArrow);
